const perPage = 100;

/*
 * This serves to retrieve all records from a paginated endpoint. It does
 * this by requesting pages until it receives an empty response. Example
 * usage:
 *
 * componentWillMount() {
 *  recordCollector(api).then(records => this.setState({ records }));
 * }
 */
export default function recordCollector(api) {
  let page = 1;
  let records = [];

  const crank = () =>
    api(page, perPage).then(resp => {
      const { results } = resp.data;

      records = records.concat(results);

      if (results.length === perPage) {
        page += 1;
        return crank();
      }

      return records;
    });

  return crank().then(() => records);
}



// WEBPACK FOOTER //
// ./app/lib/recordCollector.js